import React, { useState } from "react";
import aws from "../../assets/Core-icons/Dynamic_tech_stack/aws.svg";
import cloud_img from "../../assets/Core-icons/Dynamic_tech_stack/googlecloud.svg";
import azure from "../../assets/Core-icons/Dynamic_tech_stack/azure.svg";
import digital from "../../assets/Core-icons/Dynamic_tech_stack/digitalocean.svg";
import firebse from "../../assets/Core-icons/Dynamic_tech_stack/firebase.svg";

import mysql from "../../assets/Core-icons/Dynamic_tech_stack/mysql.svg";
import postsql from "../../assets/Core-icons/Dynamic_tech_stack/postgresql.svg";
import mongodb from "../../assets/Services/mongodb_new.png";
import cassandra from "../../assets/Core-icons/Dynamic_tech_stack/cassandra.svg";

import php from "../../assets/Core-icons/Dynamic_tech_stack/php.svg";
import net from "../../assets/Core-icons/Dynamic_tech_stack/net.svg";
import laravel from "../../assets/Core-icons/Dynamic_tech_stack/laravel.svg";
import node from "../../assets/Core-icons/Dynamic_tech_stack/nodejs.svg";
import python from "../../assets/Core-icons/Dynamic_tech_stack/python.svg";

import photoshop from "../../assets/Core-icons/Dynamic_tech_stack/photoshop.png";
import Illustator from "../../assets/Core-icons/Dynamic_tech_stack/illustrator.png";
import Sketch from "../../assets/Core-icons/Dynamic_tech_stack/sketch.svg";
import Figma from "../../assets/Core-icons/Dynamic_tech_stack/figma.svg";
import XD from "../../assets/Core-icons/Dynamic_tech_stack/xd.png";

import react from "../../assets/Core-icons/Dynamic_tech_stack/react.svg";
import Ionic from "../../assets/Core-icons/Dynamic_tech_stack/Ionic.svg";
import Apple from "../../assets/Core-icons/Dynamic_tech_stack/apple_ui_kit.svg";
import ARKit from "../../assets/Core-icons/Dynamic_tech_stack/arkit.svg";
import Core_ML from "../../assets/Core-icons/Dynamic_tech_stack/ML.png";
import Core_Image from "../../assets/Core-icons/Dynamic_tech_stack/Ios.png";
import Core_Audio from "../../assets/Core-icons/Dynamic_tech_stack/core_audio.svg";
import CoreData from "../../assets/Core-icons/Dynamic_tech_stack/core_data.svg";

import obj from '../../assets/Core-icons/Dynamic_tech_stack/objective-c.svg'
import Swift from '../../assets/Core-icons/Dynamic_tech_stack/swift.svg'
import Flutter from '../../assets/Core-icons/Dynamic_tech_stack/flutter.svg'
import Reacts  from '../../assets/Core-icons/Dynamic_tech_stack/react.svg'
import Kotlin from '../../assets/Core-icons/Dynamic_tech_stack/kotlin.svg'
const CoreComponent9 = () => {
  const content1 = [
    {
      icon: obj,
      title: "Objective-C",
    },
    {
      icon: Swift,
      title: "Swift",
    },
    {
      icon: Flutter,
      title: "Flutter",
    },
    {
      icon: Reacts,
      title: "React",
    },
    {
      icon:Kotlin,
      title: "Kotlin",
    },
  ];
  const content2 = [
    {
      icon: react,
      title: "React",
    },
    {
      icon: Ionic,
      title: "Ionic",
    },
    {
      icon: Apple,
      title: "Apple UI Kit",
    },
    {
      icon: ARKit,
      title: "ARKit",
    },
    {
      icon: Core_ML,
      title: " Core ML",
    },
    {
      icon: Core_Image,
      title: "Core Image",
    },
    {
      icon: Core_Audio,
      title: " Core Audio",
    },
      {
      icon: CoreData,
      title: " CoreData",
    },
  ];
  const content3 = [
    {
      icon: photoshop,
      title: "Photoshop",
    },
    {
      icon: Illustator,
      title: "Illustator",
    },
    {
      icon: Sketch,
      title: "Sketch",
    },
    {
      icon: Figma,
      title: "Figma",
    },
    {
      icon: XD,
      title: "XD",
    },
  ];
  const content4 = [
    {
      icon: php,
      title: "PHP",
    },
    {
      icon: net,
      title: ".Net",
    },
    {
      icon: laravel,
      title: "Laravel",
    },
    {
      icon: node,
      title: "Node.Js",
    },
    {
      icon: python,
      title: "Python",
    },
  ];
  const content5 = [
    {
      icon: aws,
      title: "Amazon AWS",
    },
    {
      icon: azure,
      title: "Azure",
    },
    {
      icon: cloud_img,
      title: "Google Cloud",
    },
    {
      icon: digital,
      title: "Digital Ocean",
    },
    {
      icon: firebse,
      title: "Firebase",
    },
  ];
  const content6 = [
    {
      icon: mysql,
      title: "MySQL",
    },
    {
      icon: postsql,
      title: "PostgreSQL",
    },
    {
      icon: mongodb,
      title: "MongoDB",
    },
    {
      icon: cassandra,
      title: "Cassandra",
    },
  ];
  const [Programming, setProgramming] = useState(true);
  const [Framework, setFramework] = useState(false);
  const [uiux, setUiux] = useState(false);
  const [Backend, setBackend] = useState(false);
  const [cloud, setCloud] = useState(false);
  const [database, setDatabase] = useState(false);

  const handleClick = () => {
    setProgramming(true);
    setFramework(false);
    setUiux(false);
    setBackend(false);
    setCloud(false);
    setDatabase(false);
  };
  const handleClick2 = () => {
    setProgramming(false);
    setFramework(true);
    setUiux(false);
    setBackend(false);
    setCloud(false);
    setDatabase(false);
  };
  const handleClick3 = () => {
    setProgramming(false);
    setFramework(false);
    setUiux(true);
    setBackend(false);
    setCloud(false);
    setDatabase(false);
  };
  const handleClick4 = () => {
    setProgramming(false);
    setFramework(false);
    setUiux(false);
    setBackend(true);
    setCloud(false);
    setDatabase(false);
  };
  const handleClick5 = () => {
    setProgramming(false);
    setFramework(false);
    setUiux(false);
    setBackend(false);
    setCloud(true);
    setDatabase(false);
  };
  const handleClick6 = () => {
    setProgramming(false);
    setFramework(false);
    setUiux(false);
    setBackend(false);
    setCloud(false);
    setDatabase(true);
  };
  return (
    <div>
      <div className="mx-lg-5 px-lg-5">
        <div className="d-flex justify-content-evenly align-items-center mb-50 flex-wrap mb-3 gap-2 gap-lg-0">
          <button
            onClick={handleClick}
            className={`  h3-para mb-3 ${
              Programming ? "text-underline-gradient" : ""
            } ${Programming ? "fw-semibold" : " fw-less"}`}
          >
            Programming{" "}
          </button>
          <button
            onClick={handleClick2}
            className={`  h3-para mb-3  ${
              Framework ? "text-underline-gradient" : ""
            } ${Framework ? "fw-semibold" : " fw-less"}`}
          >
            Framework
          </button>
          <button
            onClick={handleClick3}
            className={`   h3-para mb-3  ${uiux ? "text-underline-gradient" : ""} ${
              uiux ? "fw-semibold" : " fw-less"
            }`}
          >
            UI/UX{" "}
          </button>
          <button
            onClick={handleClick4}
            c
            className={`  h3-para  mb-3 ${
              Backend ? "text-underline-gradient" : ""
            }  ${Backend ? "fw-semibold text-underline-gradient ": " fw-less"}`}
          >
            Backend
          </button>
          <button
            onClick={handleClick5}
            c
            className={`  h3-para mb-3 ${cloud ? "text-underline-gradient" : ""}  ${
              cloud ? "fw-semibold" : " fw-less"
            }`}
          >
            Cloud
          </button>
          <button
            onClick={handleClick6}
            className={`  h3-para mb-3 ${
              database ? "text-underline-gradient" : ""
            }  ${database ? "fw-semibold" : " fw-less"}`}
          >
            Database
          </button>
        </div>
        {/* <! code starts from here !ooo /!> */}

        <div className="">
          <>
            {Programming && (
              <div className=" d-flex justify-content-center flex-wrap " >
                {content1.map((val, i) => (
                  <div className=" mx-2 mb-2 " key={i}>
                    <img
                      src={val.icon}
                      alt=""
                      className="bg-light p-md-4 p-2 m-0 icon-50"
                      style={{ width: 100, height: 100 }}
                    />
                    <p className="mt-md-3 mt-1 h3-para">{val.title}</p>
                  </div>
                ))}
              </div>
            )}
          </>
          <>
            {Framework && (
              <div className="d-flex justify-content-center flex-wrap ">
                {content2.map((val, i) => (
                  <div className=" mx-2 mb-2" key={i}>
                    <img
                      src={val.icon}
                      alt=""
                      className="bg-light p-md-4 p-2 m-0 icon-50"
                      style={{ width: 100, height: 100 }}
                    />
                    <p className="mt-md-3 mt-1 h3-para">{val.title}</p>
                  </div>
                ))}
              </div>
            )}
          </>
          <>
            {uiux && (
              <div className="d-flex justify-content-center flex-wrap ">
                {content3.map((val, i) => (
                  <div className=" mx-2 mb-2" key={i}>
                    <img
                      src={val.icon}
                      alt=""
                      className="bg-light p-md-4 p-2 m-0 icon-50"
                      style={{ width: 100, height: 100 }}
                    />
                    <p className="mt-md-3 mt-1 h3-para">{val.title}</p>
                  </div>
                ))}
              </div>
            )}
          </>
          <>
            {Backend && (
              <div className="d-flex justify-content-center flex-wrap ">
                {content4.map((val, i) => (
                  <div className=" mx-2 mb-2" key={i}>
                    <img
                      src={val.icon}
                      alt=""
                      className="bg-light p-md-4 p-2 m-0 icon-50"
                      style={{ width: 100, height: 100 }}
                    />
                    <p className="mt-md-3 h3-para">{val.title}</p>
                  </div>
                ))}
              </div>
            )}
          </>
          <>
            {cloud && (
              <div className="d-flex justify-content-center flex-wrap ">
                {content5.map((val, i) => (
                  <div className=" mx-2 mb-2" key={i}>
                    <img
                      src={val.icon}
                      alt=""
                      className="bg-light p-4 m-0 icon-50"
                      style={{ width: 100, height: 100 }}
                    />
                    <p className="mt-md-3 mt-1 h3-para">{val.title}</p>
                  </div>
                ))}
              </div>
            )}
          </>
          <>
            {database && (
              <div className="d-flex justify-content-center flex-wrap ">
                {content6.map((val, i) => (
                  <div className=" mx-2 mb-2" key={i}>
                    <img
                      src={val.icon}
                      alt=""
                      className="bg-light p-md-4 p-2 m-0 icon-50"
                      style={{ width: 100, height: 100 }}
                    />
                    <p className="mt-md-3 mt-1 h3-para">{val.title}</p>
                  </div>
                ))}
              </div>
            )}
          </>
        </div>
      </div>
    </div>
  );
};

export default CoreComponent9;
